import api from "@/services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ListParams } from "../types/common";
import { SaveBannerPayload } from "../types/bannerType";

export const getBannerList = createAsyncThunk("/banner/list", async (params: ListParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.keyword) query.set("keyword", params.keyword);
  const response = (await api.get(`/banners?${query.toString()}`)).data;
  return response;
});

export const saveBanner = createAsyncThunk("/banner/save", async (payload: SaveBannerPayload) => {
  const response = (await api.post("/banners/action", payload)).data;
  return response;
});

export const deleteBanner = createAsyncThunk("/banner/delete", async (id: number) => {
  const response = (await api.get(`/banners/delete/${id}`)).data;
  return response;
});
